import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { authGuard, guestGuard, onboardingGuard, onboardingPendingGuard } from '@common/guards';
import { UserSettingsService } from '@common/services';

export const routes: Routes = [
  {
    path: 'auth',
    canMatch: [guestGuard],
    loadChildren: () => import('./modules/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'onboarding',
    canMatch: [authGuard, onboardingPendingGuard],
    loadChildren: () =>
      import('./modules/onboarding/onboarding.routes').then((m) => m.ONBOARDING_ROUTES),
  },
  {
    path: '',
    canMatch: [authGuard, onboardingGuard],
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then((m) => m.GrMainLayoutComponent),
    children: [
      // Arriving with no path opens the person's chosen start page.
      { path: '', pathMatch: 'full', redirectTo: () => inject(UserSettingsService).landingUrl() },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: 'guests',
        loadChildren: () => import('./modules/guests/guests.routes').then((m) => m.GUESTS_ROUTES),
      },
      {
        path: 'reviews',
        loadChildren: () => import('./modules/reviews/reviews.routes').then((m) => m.REVIEWS_ROUTES),
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./modules/accounts/accounts.routes').then((m) => m.ACCOUNTS_ROUTES),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./modules/account/account.routes').then((m) => m.ACCOUNT_ROUTES),
      },
      {
        path: 'service-tickets',
        loadChildren: () =>
          import('./modules/service-tickets/service-tickets.routes').then(
            (m) => m.SERVICE_TICKETS_ROUTES,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./modules/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
      },
      {
        path: 'department-management',
        loadChildren: () =>
          import('./modules/department-management/department-management.routes').then(
            (m) => m.DEPARTMENT_MANAGEMENT_ROUTES,
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
      },
      // The user menu linked to these before personal settings existed.
      { path: 'profile', redirectTo: 'settings/profile' },
      { path: 'account-settings', redirectTo: 'settings' },
      {
        path: 'organizations',
        loadChildren: () =>
          import('./modules/organizations/organizations.routes').then(
            (m) => m.ORGANIZATIONS_ROUTES,
          ),
      },
      // Signed-in users get a real 404 inside the app chrome rather than a silent
      // bounce to the dashboard, which reads as "the link worked" when it didn't.
      {
        path: '**',
        loadComponent: () =>
          import('./modules/not-found').then((m) => m.GrNotFoundComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
